import {
  SAVE_SALES_HOURS, CLEAN_SALES_HOURS, SUCCESS, START, ERROR, LIST_SALES_HOURS
} from '../actions/types';
import { getError } from '../../utils/requestUtils';

const INITIAL_STATE = {
  salesHours: [],

  listSalesHours: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;
  const error = getError(action.payload);

  switch (action.type) {
    case CLEAN_SALES_HOURS + SUCCESS:
      return { ...state, salesHours: [] };

    case LIST_SALES_HOURS + START:
      return { ...state, listSalesHours: { loading: true } };
    case LIST_SALES_HOURS + SUCCESS:
      return { ...state, listSalesHours: { loading: false }, salesHours: data.items };
    case LIST_SALES_HOURS + ERROR:
      return { ...state, listSalesHours: { loading: false, error } };

    case SAVE_SALES_HOURS + START:
      return { ...state, saveSalesHours: { loading: true } };
    case SAVE_SALES_HOURS + SUCCESS:
      return { ...state, saveSalesHours: { loading: false }, salesHours: data.items };
    case SAVE_SALES_HOURS + ERROR:
      return { ...state, saveSalesHours: { loading: false, error } };

    default:
      return { ...state };
  }
}
